export var PaymentCollectionType;
(function (PaymentCollectionType) {
    PaymentCollectionType["PMT_UNKNOWN"] = "PMT_UNKNOWN";
    /** Recurring payment */
    PaymentCollectionType["SUBSCRIPTION"] = "SUBSCRIPTION";
    /** Not billed */
    PaymentCollectionType["NON_PAYABLE"] = "NON_PAYABLE";
    /** One time payment */
    PaymentCollectionType["ONE_TIME"] = "ONE_TIME";
})(PaymentCollectionType || (PaymentCollectionType = {}));
export var PremiumAssetType;
(function (PremiumAssetType) {
    PremiumAssetType["UNKNOWN_ASSET_TYPE"] = "UNKNOWN_ASSET_TYPE";
    /**
     * lan is a package purchased by the user
     * Plan enables or disables usage of plan capabiltieis for a specific site
     */
    PremiumAssetType["PLAN"] = "PLAN";
    /** omain can be a domain purchased through Wix or a domain purchased outside of Wix but configured to use Wix */
    PremiumAssetType["DOMAIN"] = "DOMAIN";
    /** ailbox purchased through Wix */
    PremiumAssetType["MAILBOX"] = "MAILBOX";
    /** ix or third party app */
    PremiumAssetType["APP"] = "APP";
    /** tock image, logo or other on-time-payment premium asset */
    PremiumAssetType["DIGITAL_GOOD"] = "DIGITAL_GOOD";
    /** ynamic product, created using the product catalog */
    PremiumAssetType["CATALOG_PRODUCT"] = "CATALOG_PRODUCT";
})(PremiumAssetType || (PremiumAssetType = {}));
/** tatus of the SBS Service - Wix billing service entity which is equivalent to an asset in the SBS billing system) */
export var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["UNKNOWN_SERVICE_STATUS"] = "UNKNOWN_SERVICE_STATUS";
    /** SBS service status: ACTIVE, STARTED, PENDING_RENEWAL, SUBMITTED, COMPLETED, WORK_IN_PROGRESS, COLLECTIONS, SUSPENDED */
    ServiceStatus["ACTIVE"] = "ACTIVE";
    /** SBS service status: CANCELED , EXPIRED, STOPPED FAILED, FRAUDULENT, PENDING */
    ServiceStatus["NOT_ACTIVE"] = "NOT_ACTIVE";
    /** SBS service status: TRANSFERRED */
    ServiceStatus["TRANSFERRED"] = "TRANSFERRED";
    /** Used when creating subscription for product that was initially purchased by a non real time payment method such as Boleto ot SEPA and can take a while to be delivered */
    ServiceStatus["PENDING_SERVICE_STATUS"] = "PENDING_SERVICE_STATUS";
})(ServiceStatus || (ServiceStatus = {}));
export var BillingCycle;
(function (BillingCycle) {
    BillingCycle["ONE_TIME"] = "ONE_TIME";
    BillingCycle["DAILY"] = "DAILY";
    BillingCycle["WEEKLY"] = "WEEKLY";
    BillingCycle["MONTHLY"] = "MONTHLY";
    BillingCycle["QUARTERLY"] = "QUARTERLY";
    BillingCycle["SEMI_ANNUALLY"] = "SEMI_ANNUALLY";
    BillingCycle["YEARLY"] = "YEARLY";
    BillingCycle["TWO_YEARS"] = "TWO_YEARS";
    BillingCycle["THREE_YEARS"] = "THREE_YEARS";
    BillingCycle["FOUR_YEARS"] = "FOUR_YEARS";
    BillingCycle["FIVE_YEARS"] = "FIVE_YEARS";
})(BillingCycle || (BillingCycle = {}));
export var RenewalType;
(function (RenewalType) {
    RenewalType["UNKNOWN"] = "UNKNOWN";
    /** ubscription renewed when current period ends with automatic payment method, for example credit card */
    RenewalType["AUTO_RENEW_ON"] = "AUTO_RENEW_ON";
    /** ubscription is turned off at current period end date */
    RenewalType["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    /** ubscription is renewed when current period ends only if paid for manually */
    RenewalType["MANUAL"] = "MANUAL";
})(RenewalType || (RenewalType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    /** Billing system status: VOID or Unknown type */
    PaymentStatus["UNKNOWN_PAYMENT_STATUS"] = "UNKNOWN_PAYMENT_STATUS";
    /** Billing system status: Closed */
    PaymentStatus["PAID"] = "PAID";
    /** Billing system invoice status: CREDIT_NOTE, ERROR_CHARGES, DECLINED_CHARGES , BAD_DEBT */
    PaymentStatus["CHARGE_FAILURE"] = "CHARGE_FAILURE";
    PaymentStatus["REFUNDED"] = "REFUNDED";
    /** Billing system invoice status = Due , PAYMENT_IN_PROGRESS */
    PaymentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Invoice was never created for asset, mostly transferred assets */
    PaymentStatus["NO_PAYMENT"] = "NO_PAYMENT";
    /** Manual_payment_pending? */
    PaymentStatus["NOT_BILLABLE"] = "NOT_BILLABLE";
})(PaymentStatus || (PaymentStatus = {}));
export var PremiumPlanDataModelType;
(function (PremiumPlanDataModelType) {
    PremiumPlanDataModelType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    /** lan created sold and delivered by dynamic offering framework */
    PremiumPlanDataModelType["DYNAMIC_OFFERING"] = "DYNAMIC_OFFERING";
    /** lan created sold and delivered by the legacy plan system */
    PremiumPlanDataModelType["LEGACY_PREMIUM_PLANS"] = "LEGACY_PREMIUM_PLANS";
})(PremiumPlanDataModelType || (PremiumPlanDataModelType = {}));
export var DomainManagementType;
(function (DomainManagementType) {
    DomainManagementType["DMT_UNKNOWN"] = "DMT_UNKNOWN";
    /** omain subscription purchased from Wix and billed by Wix */
    DomainManagementType["WIX_DOMAIN"] = "WIX_DOMAIN";
    /**
     * omain purchased outside of Wix, DNS managed by external registrar and configured
     * to point to Wix
     */
    DomainManagementType["EXTERNAL_POINTING_DOMAIN"] = "EXTERNAL_POINTING_DOMAIN";
    /**
     * omain purchased from external registrar, DNS configured to the Wix name server and
     * DNS records are stored and managed by Wix
     */
    DomainManagementType["EXTERNAL_DNS_MANAGED"] = "EXTERNAL_DNS_MANAGED";
})(DomainManagementType || (DomainManagementType = {}));
export var DomainPrivacyStatus;
(function (DomainPrivacyStatus) {
    DomainPrivacyStatus["DPS_UNKNOWN"] = "DPS_UNKNOWN";
    /** rivacy feature not purchased for this domain */
    DomainPrivacyStatus["NO_PRIVACY_PURCHASED"] = "NO_PRIVACY_PURCHASED";
    /** rivacy feature purchased and enabled */
    DomainPrivacyStatus["PRIVACY_TURNED_ON"] = "PRIVACY_TURNED_ON";
    /** rivacy feature purchased and disabled */
    DomainPrivacyStatus["PRIVACY_TURNED_OFF"] = "PRIVACY_TURNED_OFF";
})(DomainPrivacyStatus || (DomainPrivacyStatus = {}));
export var MailboxVendorType;
(function (MailboxVendorType) {
    MailboxVendorType["UNKNOWN_MAILBOX_TYPE"] = "UNKNOWN_MAILBOX_TYPE";
    /** G-Suite used for mail */
    MailboxVendorType["GOOGLE"] = "GOOGLE";
    /** MSN Office Suite used for mail */
    MailboxVendorType["MSN"] = "MSN";
})(MailboxVendorType || (MailboxVendorType = {}));
export var DigitalGoodType;
(function (DigitalGoodType) {
    DigitalGoodType["UNKNOWN_DIGITAL_GOOD_TYPE"] = "UNKNOWN_DIGITAL_GOOD_TYPE";
    DigitalGoodType["IMAGE"] = "IMAGE";
    DigitalGoodType["VIDEO"] = "VIDEO";
    DigitalGoodType["LOGO"] = "LOGO";
})(DigitalGoodType || (DigitalGoodType = {}));
export var ProductTypeContext;
(function (ProductTypeContext) {
    ProductTypeContext["UNKNOWN"] = "UNKNOWN";
    /** Products of this type must be at account level and can only have one subscription per account */
    ProductTypeContext["ACCOUNT"] = "ACCOUNT";
    /**
     * Products of this type can be assigned to a site and can only have one subscription per site
     * if ProductSubscriptionSettings has allow_disconnect_from_context then it can also be floating (at account level)
     */
    ProductTypeContext["SITE"] = "SITE";
})(ProductTypeContext || (ProductTypeContext = {}));
export var AllowedAction;
(function (AllowedAction) {
    AllowedAction["UNKNOWN"] = "UNKNOWN";
    /** asset will be transferred (remain connected to the site) on site transfer between accounts */
    AllowedAction["TRANSFER"] = "TRANSFER";
    /** disconnect an asset from a site */
    AllowedAction["DISCONNECT"] = "DISCONNECT";
    AllowedAction["UPDATE_PAYMENT_METHOD"] = "UPDATE_PAYMENT_METHOD";
    /** assign asset to another site */
    AllowedAction["CONNECT_DISCONNECT_TO_SITE"] = "CONNECT_DISCONNECT_TO_SITE";
    AllowedAction["CHANGE_CYCLE"] = "CHANGE_CYCLE";
    AllowedAction["CHANGE_PRODUCT"] = "CHANGE_PRODUCT";
})(AllowedAction || (AllowedAction = {}));
export var CancellationPolicy;
(function (CancellationPolicy) {
    CancellationPolicy["UNKNOWN"] = "UNKNOWN";
    CancellationPolicy["TRIAL_CANCELLATION"] = "TRIAL_CANCELLATION";
    CancellationPolicy["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    CancellationPolicy["NOT_CANCELABLE"] = "NOT_CANCELABLE";
})(CancellationPolicy || (CancellationPolicy = {}));
export var ProviderName;
(function (ProviderName) {
    ProviderName["UNKNOWN"] = "UNKNOWN";
    ProviderName["SBS"] = "SBS";
    ProviderName["LICENSER"] = "LICENSER";
    ProviderName["BASS"] = "BASS";
    ProviderName["RESELLER"] = "RESELLER";
    ProviderName["RECURRING_INVOICES"] = "RECURRING_INVOICES";
})(ProviderName || (ProviderName = {}));
export var SiteAssignment;
(function (SiteAssignment) {
    SiteAssignment["UNKNOWN"] = "UNKNOWN";
    SiteAssignment["All"] = "All";
    SiteAssignment["ASSIGN_ONLY"] = "ASSIGN_ONLY";
    SiteAssignment["UN_ASSIGN_ONLY"] = "UN_ASSIGN_ONLY";
})(SiteAssignment || (SiteAssignment = {}));
export var PremiumStatus;
(function (PremiumStatus) {
    PremiumStatus["UNKNOWN_PREMIUM_STATUS"] = "UNKNOWN_PREMIUM_STATUS";
    /** Site does not have a premium plan connected to it */
    PremiumStatus["FREE"] = "FREE";
    /** Site has a pending premium plans connected to it, that will become active one payment is approved */
    PremiumStatus["PENDING"] = "PENDING";
    /** Site has an active premium plan connected to it */
    PremiumStatus["PREMIUM"] = "PREMIUM";
})(PremiumStatus || (PremiumStatus = {}));
//# sourceMappingURL=types.impl.js.map